var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 13.3333C10.9467 13.3333 13.3333 10.9467 13.3333 8C13.3333 5.05333 10.9467 2.66667 8.00001 2.66667C5.05334 2.66667 2.66668 5.05333 2.66668 8C2.66668 10.9467 5.05334 13.3333 8.00001 13.3333ZM8.00001 14.6667C4.32001 14.6667 1.33334 11.68 1.33334 8C1.33334 4.32 4.32001 1.33333 8.00001 1.33333C11.68 1.33333 14.6667 4.32 14.6667 8C14.6667 11.68 11.68 14.6667 8.00001 14.6667ZM7.81334 8.14C8.60668 7.96 9.07334 8.16667 9.66001 8.75333L10.8067 9.89333L9.86001 10.84L7.72668 8.7C7.48001 8.44667 7.33334 8.11333 7.33334 7.76V4.00667H8.66668V6.40667C8.66668 7.23333 8.46001 7.63333 7.78001 8.07333L7.81334 8.14Z",
    fill: "#2B2D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlog);
export default __webpack_public_path__ + "static/media/ClockBlog.c44e107ad6ff42bc052ca8c403266106.svg";
export { ForwardRef as ReactComponent };